import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import { Row, Col, Form, Icon, Input, Button, Checkbox } from 'antd';
import {loginUser} from '../actions';

const FormItem = Form.Item;

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: {}
        }
    }
    handleServerError(values) {
        const {state: {serverErrors: {error, message}}, props: {form}} = this;
        const {username, password} = values;
        if (error) {
            form.setFields({
                username: {
                    value: username,
                    errors: [new Error(message)]
                },
                password: {
                    value: password,
                    errors: [new Error(message)]
                }
            })
        }
    }
    handleSubmit(e) {
        e.preventDefault();
        const {form, loginUser} = this.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            return loginUser(values).then(() => this.handleServerError(values));
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        if (this.props.isAuthenticated) {
            return <Redirect to="/"/>;
        }

        return (
            <Row style={{ marginTop: '100px' }}>
                <Col md={{span: 10, offset: 7}} lg={{span: 8, offset: 8}} xl={{span: 6, offset: 9}}>
                    <Form onSubmit={this.handleSubmit.bind(this)} className="login-form" style={{padding: '40px'}}>
                        <FormItem hasFeedback>
                            {getFieldDecorator('username', {
                                rules: [
                                    { required: true, message: 'Please input your email address!' },
                                    { type: 'email', message: 'The input is not valid E-mail!' }
                                ],
                            })(
                                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email address" />
                            )}
                        </FormItem>
                        <FormItem hasFeedback>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: 'Please input your Password!' }],
                            })(
                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                            )}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" className="login-form-button" style={{width: '100%'}}>
                                Log in
                            </Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        );
    }
}

Login.getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.error && !prevState.serverErrors.error) {
        return {serverErrors: nextProps.error}
    }
    if (!nextProps.error && prevState.serverErrors.error) {
        return {serverErrors: {}}
    }
    return null;
};

const WrappedNormalLoginForm = Form.create()(Login);
function mapStateToProps(state, ownProps) {
    return Object.assign({}, state.auth);
}
export default connect(mapStateToProps, {loginUser})(WrappedNormalLoginForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Login.js